import * as R from "ramda";

export type TranscriptMessage = {
  speaker: string;
  speakerInitials: string;
  timestamp: string;
  text: string;
};

export const getInitials = (name: string): string =>
  R.pipe(
    R.trim,
    R.split(/\s+/),
    R.reject(R.isEmpty),
    R.map(word => R.defaultTo("", R.head(word)).toUpperCase()),
    R.slice(0, 2),
    R.join("")
  )(name);

export const extractMatches = (transcript: string, regex: RegExp, acc: TranscriptMessage[] = []): TranscriptMessage[] => {
  // regex.exec maintains internal pointer, this allows us to call it and get the next match
  const match = regex.exec(transcript);

  if (!match) {
    return acc;
  }

  const speaker = match[1];
  const speakerInitials = getInitials(speaker);
  const timestamp = R.defaultTo("", match[2]);
  const text = match[3].trim();

  const newMessage = { speaker, speakerInitials, timestamp, text };

  return extractMatches(transcript, regex, [...acc, newMessage]);
};

export const parseTranscript = (transcriptText: string): TranscriptMessage[] => {
  if (!transcriptText) {
    return [];
  }

  const trimmedTranscript = transcriptText.trim();
  const messageRegex = /\[(.*?)(?:\s+\((.*?)\))?\]: ([\s\S]*?)(?=\r?\n\s*\[.*?(?:\s+\(.*?\))?\]: |$)/g;

  return extractMatches(trimmedTranscript, messageRegex);
};
